import React, { FC, ReactNode } from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

interface IComponentProps {
  children?: ReactNode;
}

export const PageFooter: FC<IComponentProps> = ({ children }) => {
  return <Footer className="page-footer">{children}</Footer>;
};
